import Image from 'next/image';
import Link from 'next/link';

import styles from './white-label-footer.module.css';
import { WhiteLabelFooterProps } from './white-label-footer.types';

export const WhiteLabelFooter = ({
  logo: { href: logoHref, ...logo },
  urls,
  onShowConsentModal,
  showPrivacy = true,
  content,
  style,
}: WhiteLabelFooterProps) => (
  <div className={styles.whiteLabelFooter} style={style}>
    <div className={styles.wrapper}>
      <Link href={logoHref} className={styles.logo}>
        <Image {...logo} alt="Logo" />
      </Link>

      <div className={styles.links}>
        {urls.map(({ label, href }) => (
          <Link key={href.toString()} href={href}>
            {label}
          </Link>
        ))}
        {showPrivacy && (
          <button onClick={onShowConsentModal} className={styles.privacySettings}>
            {content.privacySettings}
          </button>
        )}
      </div>
    </div>
  </div>
);
